import { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getPathWithoutLanguage, createLocalizedPath } from '../../utils/languageUtils'

/**
 * Компонент-обертка для роутов с языковым префиксом
 * Автоматически определяет язык из URL и устанавливает его в i18n
 * Редиректит на валидный язык, если передан невалидный
 */
function LanguageRoute({ children }) {
  const { lang } = useParams()
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const validLanguages = ['en', 'ru', 'ja']
    const detectedLang = lang && validLanguages.includes(lang) ? lang : 'en'
    
    // Если язык невалидный, редиректим на валидный язык
    if (lang && !validLanguages.includes(lang)) {
      const pathWithoutLang = getPathWithoutLanguage(location.pathname)
      const newPath = createLocalizedPath(pathWithoutLang, 'en')
      navigate(`${newPath}${location.search}${location.hash}`, { replace: true })
      return
    }
    
    // Устанавливаем язык, если он отличается от текущего
    if (i18n.language !== detectedLang) {
      i18n.changeLanguage(detectedLang)
    }
  }, [lang, i18n.language, navigate, location.pathname, location.search, location.hash])

  return children
}

export default LanguageRoute
